<template>
<div style="padding: 15px;height: 100vh; overflow: scroll; background: #2562af;" class="Kanit">
  <v-img src="/static/img/icons/logoonechat_full-white.png" style="max-width: 250px; margin:auto;"/>
<div class="bginform">

<router-view></router-view>

</div>
</div>
</template>

<script>


export default {
  data: () => ({
    
  }),
  components: {
  },
  created() {
    // this.onechat_token = this.$route.query.onechat_token
    // this.checkform(this.$route.query.onechat_token)
    // this.$i18n.locale = (this.$cookie.get('language'))? this.$cookie.get('language'): 'th'
  },
  methods: {
    
    
  }
}
</script>

<style type="text/css" scoped>
.Kanit {
  font-family: 'Kanit' !important;
  word-wrap: break-word;
}
.rate {
  float: left;
  /*text-align: left;*/
    height: 46px;
    padding: 0 10px;
}
.rate:not(:checked) > input {
    position:absolute;
    top:-9999px;
}
.rate:not(:checked) > label {
   float: right;
    width:1em;
    overflow:hidden;
    white-space:nowrap;
    cursor:pointer;
    font-size:30px;
    color:#ccc;
}
.rate:not(:checked) > label:before {
    content: '★ ';
}
.rate > input:checked ~ label {
    color: #ffc700;    
}
.rate:not(:checked) > label:hover,
.rate:not(:checked) > label:hover ~ label {
    color: #deb217;  
}
.rate > input:checked + label:hover,
.rate > input:checked + label:hover ~ label,
.rate > input:checked ~ label:hover,
.rate > input:checked ~ label:hover ~ label,
.rate > label:hover ~ input:checked ~ label {
    color: #c59b08;
}

.rowForm {
  margin-top: 10px;
  display: table;
}
.InputEdit {
    height: 43px;
    width: calc(100vw - 50px);
    max-width: 500px;
    padding: 5px 15px !important;
    background-color: #fff;
    border: 1px solid #d2d8dd;
    border-radius: 4px;
    margin-bottom: 15px !important;
}

>>>.v-input--radio-group--column .v-radio:not(:last-child):not(:only-child) {
     margin-bottom: 0px !important; 
}


>>>.v-textarea.v-text-field--enclosed .v-text-field__slot textarea {
    /* padding-right: 12px; */
    /*font-size: 14px;*/
    font-size: 14px;
    resize: none;
    height: 75px !important;
}
>>>.v-text-field.v-text-field--full-width.v-input {
    padding: 0;
    padding-left: 10px !important;
}
>>>.v-input--selection-controls.v-input .v-label {
    font-size: 14px !important;
    color: #202020 !important;
}
>>>.v-input--selection-controls {
    margin-top: 0px !important;
    padding-top: 0px !important;
}
.bginform {
    background: white;
    padding: 10px;
    border-radius: 15px;
}

  select, textarea, input {
    width: 100%;
    font-size: 16px;
  }

  select:focus, textarea:focus, input:focus {
    width: 100%;
    font-size: 16px;
  }
  input[type=text]:focus {
    width: 100%;
    font-size: 16px;
  }
  .iconLanguage {
  height: 25px;
  cursor: pointer;
  margin-top: 7px;
}

</style>



// WEBPACK FOOTER //
// src/components/consent/consent.vue